"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var eventsHelper_1 = require("../utils/eventsHelper");
var Expand = /** @class */ (function () {
    function Expand(rootElement) {
        this.rootElement = rootElement;
        eventsHelper_1.default.live('.js-expand', eventsHelper_1.default.clickOrTouchEvent, function (event, clickedElement) {
            event.preventDefault();
            toggleElement(clickedElement);
        }, this.rootElement);
        function toggleElement(element) {
            var target = "";
            if (element.getAttribute('href')) {
                target = element.getAttribute('href');
            }
            else if (element.getAttribute('data-target')) {
                target = element.getAttribute('data-target');
            }
            if (target != "") {
                var targetElement = rootElement.querySelector(target);
                if (targetElement) {
                    targetElement.classList.toggle('is-showing');
                    element.classList.toggle('.is-open');
                    if (element.getAttribute("aria-expanded")) {
                        element.setAttribute('aria-expanded', true);
                    }
                    else {
                        element.setAttribute('aria-expanded', false);
                    }
                }
            }
        }
    }
    return Expand;
}());
exports.default = Expand;
